var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import axios from "./http.js";
class LeagueApi {
  static getLeagueDetails() {
    const abortController = new AbortController();
    return {
      async call({ id, seasonId }, options = {}) {
        const extraHeaders = __spreadValues({}, options.isWC ? { isWC: options.isWC } : {});
        return axios.get(`/v5/League/${id}`, {
          signal: abortController.signal,
          params: { seasonId },
          headers: Object.keys(extraHeaders).length ? extraHeaders : void 0
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
}
var stdin_default = LeagueApi;
export {
  stdin_default as default
};
